import { Actions, Entities } from '@space-lib/datahub'

import type { COMMUNITY_TYPE } from '@space-shell/modules/communities/accessAndPrivacy/constants'

import type { CommunitiesEventsPayloadProps } from './types'
import { CommunitiesActions } from './types'

export const AMOUNT_ROWS_GET_BLOCKED_FOLLOWERS = 8

export const TOTAL_ROWS_GET_COURSES = 5

export const CommunitiesEndpoints = {
  getCommunity: (id: number) => `/rest/v1/communities/${id}`,
  deleteCommunity: (id: number) => `/rest/v1/communities/admin/${id}`,
  editCommunity: (id: number) => `/rest/v1/communities/admin/${id}`,
  createCommunity: (slug: string) => `/rest/v1/communities/admin/${slug}`,
  getGroupCommunities: (slug: string) => `/rest/v1/communityGroupsWithCommunities/${slug}`,
  getGroupCommunitiesPublic: (slug: string) =>
    `/rest/public/v2/communityGroupsWithCommunities/${slug}`,
  createGroupCommunity: () => `/rest/v1/communityGroups`,
  editGroupCommunity: (groupId: number) => `/rest/v1/communityGroups/${groupId}`,
  deleteGroupCommunity: (groupId: number, slug: string) =>
    `/rest/v2/memberships/${slug}/communityGroups/${groupId}`,
  lastViewDate: (communityId: number) =>
    `/rest/v1/collections/${communityId}/lastCollectionViewDate`,
  getPosts: (publicationId: number) => `/rest/v1/collections/${publicationId}/news`,
  getBlockedFollowers: (communityId: number) =>
    `/rest/v1/communities/admin/${communityId}/blockedFollowers`,
  putUnBlockUser: (communityId: number, idUser: number) =>
    `/rest/v1/communities/admin/${communityId}/blockedFollowers/${idUser}/unblock`,
  getCourses: (slug: string) => `/rest/v1/admin/memberships/${slug}/products/available`,
  updateCourses: (slug: string) => `/rest/v1/membership/${slug}/collectionCourses`,
  getFollowersRoles: (communityId: number) => `/v1/admin/communities/${communityId}/followersRoles`,
  getCreateCommunityPermission: (featureName: string) =>
    `/rest/v1/users/collections/feature/${featureName}`,
  editFollowerRole: (communityId: number, userId: number) =>
    `rest/v2/collections/${communityId}/members/${userId}`,
  deleteFollower: (communityId: number, ucode: string) =>
    `/v1/admin/communities/${communityId}/followers/${ucode}`,
  expirationDate: (ucode: string, hashImportedId: string) =>
    `/v1/admin/communities/followers/${ucode}/imported/${hashImportedId}`,
  changeCommunityType: (communityId: number, type: COMMUNITY_TYPE) =>
    `/v1/admin/communities/${communityId}/type/${type}`
}

export const CommunitiesEventsPayload: CommunitiesEventsPayloadProps = {
  [CommunitiesActions.ADD]: {
    entity: Entities.HOME_COMMUNITY,
    action: Actions.COMMUNITY_ADD
  },
  [CommunitiesActions.EDIT]: {
    entity: Entities.HOME_COMMUNITY,
    action: Actions.COMMUNITY_EDIT
  },
  [CommunitiesActions.DELETE]: {
    entity: Entities.HOME_COMMUNITY,
    action: Actions.COMMUNITY_DELETE
  }
}
